import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

export default function ProductTablePagination({ page, totalPages, total, limit, onPageChange }) {
    const safeTotalPages = totalPages || 1;
    const start = total === 0 ? 0 : (page - 1) * limit + 1;
    const end = Math.min(page * limit, total);

    return (
        <div className="tw-flex tw-items-center tw-justify-between tw-border-t tw-border-slate-200 tw-px-5 tw-py-4">
        <p className="tw-m-0 tw-text-sm tw-text-slate-500">
            Mostrando {start} - {end} de {total}
        </p>

        <div className="tw-flex tw-items-center tw-gap-4">
            <span className="tw-text-sm tw-font-semibold tw-text-slate-900">
            Pág. {page} de {safeTotalPages}
            </span>

            <div className="tw-flex tw-items-center tw-gap-2">
            <button
                type="button"
                disabled={page <= 1}
                onClick={() => onPageChange(page - 1)}
                className="tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-text-slate-500 tw-transition enabled:hover:tw-bg-slate-50 disabled:tw-cursor-not-allowed disabled:tw-opacity-50"
                aria-label="Página anterior"
            >
                <ChevronLeftIcon className="tw-h-4 tw-w-4" />
            </button>

            <button
                type="button"
                disabled={page >= safeTotalPages}
                onClick={() => onPageChange(page + 1)}
                className="tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-bg-cyan-600 tw-text-white tw-transition enabled:hover:tw-bg-cyan-700 disabled:tw-cursor-not-allowed disabled:tw-opacity-50"
                aria-label="Página siguiente"
            >
                <ChevronRightIcon className="tw-h-4 tw-w-4" />
            </button>
            </div>
        </div>
        </div>
    );
}